var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"md":"12"}},[_c('section',{staticClass:"accommodations"},[_c('card-recap',{attrs:{"show_header":false,"show_footer":false,"show_matching":true,"solution":_vm.solution,"accommodations":_vm.accommodations}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }